import { parseISO } from 'date-fns';
import { zonedTimeToUtc, format } from 'date-fns-tz';
import { ru } from 'date-fns/locale';
import { LOCAL_TIMEZONE } from '@/helpers/enums/index';

/**
 * Форматирование даты
 * @param {String} date - timestamp, который нужно отформатирвоать
 * @param {String} dateFormat - формат даты
 * @returns {String} - отформатированная дата
 */
export const formatDate = (date: string, dateFormat: string): string => {
  const parseISODate = parseISO(date);
  const utcDate = zonedTimeToUtc(parseISODate, 'Europe/Moscow');
  return format(utcDate, dateFormat, {
    timeZone: LOCAL_TIMEZONE,
    locale: ru,
  });
};
